module.exports = {
      id: "webatvantage-usage",
      viewBox: "0 0 106 20",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#webatvantage-usage",
      toString: function () {
        return this.url;
      }
    }